




































import Vue from 'vue'
import borderButton from '@/components/border-button.vue'
export default Vue.extend({
  data() {
    return {
      isActive: false
    }
  },
  components: { 'border-button': borderButton }
})
